export default {
	properties: [
		{
			text: 'Nombre',
			key: 'name',
			type: 'text',
			is_title: true,
		},
	],
	singular_model_name_spanish: 'Unidad de frecuencia',
	plural_model_name_spanish: 'Unidades de frecuencia',
	create_model_name_spanish: 'Nueva Unidad de frecuencia',
	text_delete: 'la',
}